import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'pp-side-panel-empty-folder-message',
    templateUrl: './side-panel-empty-folder-message.component.html',
    styleUrl: './side-panel-empty-folder-message.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelEmptyFolderMessageComponent {}
